export class BaseFilter {
}
export class ListFilter extends BaseFilter {
    constructor(type, name, values = []) {
        super();
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "values", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.type = type;
        this.name = name;
        this.values = values;
    }
    add(item) {
        this.values.push(item);
    }
    getName() {
        return this.name;
    }
    getType() {
        return this.type;
    }
    getValues() {
        return this.values;
    }
    toJson() {
        return {
            type: this.type,
            name: this.name,
            values: this.values,
        };
    }
}
export class ComparisonFilter extends BaseFilter {
    constructor(type, name, value = undefined) {
        super();
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.type = type;
        this.name = name;
        this.value = value;
    }
    getType() {
        return this.type;
    }
    getName() {
        return this.name;
    }
    getValue() {
        return this.value;
    }
    toJson() {
        return {
            type: this.type,
            name: this.name,
            value: this.value,
        };
    }
}
export class LogicOperatorFilter extends BaseFilter {
    // eslint-disable-next-line no-use-before-define
    constructor(type, filter) {
        super();
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // eslint-disable-next-line no-use-before-define
        Object.defineProperty(this, "filters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        this.type = type;
        this.filters = filter;
    }
    // eslint-disable-next-line no-use-before-define
    add(filter) {
        this.filters.push(filter);
    }
    // eslint-disable-next-line no-use-before-define
    get() {
        return this.filters;
    }
    getType() {
        return this.type;
    }
    toJson() {
        return {
            type: this.type,
            filters: this.filters.map((filter) => filter.toJson()),
        };
    }
}
